import ResolveRequiredSettings from "./resolveRequiredSettings";

export default ResolveRequiredSettings;
